import { app } from "@app/appLauncher";
import { getTool } from "@app/internal/supportToolsList/toolsList";
import FindContactDuplicatesPage from "@app/tools/contacts/findContactDuplicates/findContactDuplicatesPage";

app(<FindContactDuplicatesPage tool={getTool("find-contact-duplicates")} />);
